<template>
  <div class="wx-container">
    <img class="logoIcon" src="../../assets/images/wxlogin/icon_1.png" >
    <!-- <p class="systemTitle">浙江海岛公园大数据应用系统</p> -->
    <div class="sonSystemTitle">
      <img src="../../assets/images/wxlogin/icon_2.png">
      <span>综合展示分析系统</span>
      <img src="../../assets/images/wxlogin/icon_3.png">
    </div>
    <img class="warnImg" :src="warnImg" >
    <p class="warnText">{{warnText}}</p>
  </div>
</template>

<script>
	import Api from "@/server";
	export default {
		data() {
			return {
        warnText: '',
        warnImg: '',
        sucImg: require('../../assets/images/wxlogin/icon_4.png'),
        errImg: require('../../assets/images/wxlogin/icon_5.png'),
      }
    },
    mounted() {
			this.getSysName();
      let url = window.location.href,
          hasLogin = Api.getUrlParams(url,'hasLogin');
      if(hasLogin == 'true'){
        this.warnImg = this.sucImg;
        this.warnText = '登录成功';
      }else{
        this.warnImg = this.errImg;
        this.warnText = '登录失败';
      }
    },
		methods:{
			// 获取系统名字
			getSysName() {
				let urls = this.gup("syscode")
				this.urls = urls
				let params = {
					"systemId": urls
				};
				Api.ajaxRequest('system/query/by/systemId', params).then(res => {
					let {code,data} = res;
					if (code == '200') {
						if (res.data.systemName == null) {
							this.systemName = '统一用户中心';
						} else {
							this.systemName = res.data.systemName;
						}
					} else {
						this.systemName = '统一用户中心';
					}
				});
			},
			gup(name) {
				var regexS = "[\\?&]" + name + "=([^&#]*)"; //匹配name参数对  
				var regex = new RegExp(regexS);
				var results = regex.exec(window.location.href); //过滤超链接  
				if (results == null) {
					return "";
				} else {
					return results[1];
				}
			},
		}
  }
</script>

<style lang="less" scoped>
  .wx-container{
    width: 100vw;
    height: 100vh;
    background-image: url('../../assets/images/wxlogin/bg.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 6vh;
    
    .logoIcon{
      width: 90vw;
      height: auto;
      margin-bottom: 5vh;
    }
    
    // .systemTitle{
    //   font-size: 6.76vw;
    //   color: #ffffff;
    //   font-weight: bold;
    //   margin: 2vh 0;
    // }
    
    .sonSystemTitle{
      height: 2vh;
      margin-bottom: 6vh;
      display: flex;
      align-items: center;
      
      img{
        width: 21vw;
        height: .2vh;
      }
      
      span{
        font-size: 4.8vw;
        color: #764d22;
        opacity: 0.8;
        margin: 0 3vw;
      }
    }
    
    .warnImg{
      width: 20vw;
      height: 20vw;
    }
    
    .warnText{
      width: 30vw;
      height: 4vh;
      background-color: rgba(0,0,0,.22);
      border-radius: 4.5vw;
      margin-top: 2vh;
      font-size: 4.3vw;
      color: #fff;
      text-align: center;
      line-height: 4vh;
    }
  }
</style>
